<template>
  <div>
    <el-dialog
      :visible.sync="localShow"
      :before-close="handleClose"
      custom-class="custom-class"
      class="dialog-class"
      :show-close="false"
    >
      <div class="main-body" v-if="localShowData">
        <div class="title" :style="{ color: titleInfo.color }">
          <img :src="titleInfo.icon" />
          {{ titleInfo.text }}
          <span>({{ activeData.alarmType || alertLevelText }})</span>
        </div>
        <div :class="['content-body', contentBodyClass, 'content-body-X']">
          <div class="left">
            <!-- 优先显示图片 (适用于叶片 7, 音频 8, 安全 9) 以及 净空预警(5 且 messageType=1) -->
            <template
              v-if="
                [7, 8, 9].includes(activeData.deviceType) ||
                (activeData.deviceType == 5 && activeData.messageType == 1)
              "
            >
              <ImageShow
                class="max-img"
                :path="activeData.imagePath || activeData.alarmPictureUrl"
                @dblclick="
                  imageDetailDblclick(
                    getFullImageUrl(
                      activeData.imagePath || activeData.alarmPictureUrl
                    )
                  )
                "
              />
            </template>
            <!-- 净空报警(5 且 messageType=2) 专用视频显示 -->
            <template
              v-else-if="activeData.deviceType == 5 && activeData.messageType == 2"
            >
              <video
                class="max-img"
                :src="getFullImageUrl(activeData.videoUrl)"
                controls
                autoplay
                loop
                style="object-fit: contain; background: #000"
              >
                您的浏览器不支持 video 标签。
              </video>
            </template>
            <!-- 螺栓专用显示 -->
            <template v-else-if="activeData.deviceType == 6">
              <div class="item1">
                <img
                  :src="require('@/assets/image/wind_bolt/luoshuan1.png')"
                  @dblclick="
                    imageDetailDblclick(
                      require('@/assets/image/wind_bolt/luoshuan1.png')
                    )
                  "
                />
                <img
                  :src="require('@/assets/image/wind_bolt/luoshuan1.png')"
                  @dblclick="
                    imageDetailDblclick(
                      require('@/assets/image/wind_bolt/luoshuan1.png')
                    )
                  "
                />
                <div>原始图片</div>
                <div>问题图片</div>
              </div>
              <div
                class="item2"
                @dblclick="
                  imageDetailDblclick(
                    require('@/assets/image/wind_bolt/luoshuan4.png')
                  )
                "
              >
                <img :src="require('@/assets/image/wind_bolt/luoshuan2.jpg')" />
                <img
                  class="luoshuan"
                  :src="require('@/assets/image/wind_bolt/luoshuan3.png')"
                />
              </div>
            </template>
            <!-- 倾角专用显示 -->
            <template v-else-if="activeData.deviceType == 1">
              <angle
                :numberValue="angleDispose(activeData.currentData)"
                id="details1"
              ></angle>
            </template>
            <!-- 位移专用显示 -->
            <template v-else-if="activeData.deviceType == 2">
              <displacement
                :data="activeData.currentData"
                :angle="activeData.heading"
                :myStatic="true"
              ></displacement>
            </template>
          </div>
          <div class="right">
            <div v-if="displayDetails.title" class="right-title">
              机组号：{{ displayDetails.title }}
            </div>
            <div
              v-for="(item, index) in displayDetails.items"
              :key="index"
              class="right-value"
            >
              {{ item.label }}：{{ item.value }}
            </div>

            <div class="date">
              <div>报警时间：</div>
              <div>
                <span>{{ formattedTime.date }}</span
                ><br />
                <span>{{ formattedTime.time }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <img
        class="guanbi"
        :src="require('@/assets/image/wind/kuang4_icon.png')"
        alt=""
        srcset=""
        @click="handleClose"
      />
      <imageDetail
        :dialogVisible="dialogVisible"
        :url="imageUrl"
        @handleClose="dialogVisible = false"
        :imageis="imageis"
        class="imageDetail"
      ></imageDetail>
    </el-dialog>
  </div>
</template>
<script>
/**
 * 报警详情弹窗组件入参说明 (showData):
 *
 * --- 公共数据 ---
 * @property {number} deviceType - 设备类型 (1: 倾角, 2: 位移, 5: 净空, 6: 螺栓, 7: 叶片, 8: 音频, 9: 安全)
 * @property {string} deviceName - 机组号/设备名称
 * @property {string} alarmTime - 报警时间 (格式: YYYY-MM-DD HH:mm:ss)
 * @property {number} alarmLevel - 报警等级 (1: 一级/红色, 2: 二级/橙色, 3: 三级/黄色)
 * @property {string} alarmType - 报警类型名称 (如: "结构裂纹", "人员入侵")
 * @property {number} messageType - 消息类型 (1: 预警, 2: 报警)
 * @property {string} imagePath - 图片路径 (优先使用)
 *
 * --- 专用数据 (直接平铺在 showData 中) ---
 * @property {number} distance - 净空距离 (deviceType: 5)
 * @property {number} currentData - 监测数值 (deviceType: 1, 2, 6)
 * @property {number} heading - 航向角 (deviceType: 2)
 * @property {string} tier - 螺栓层数 (deviceType: 6)
 * @property {string} cameraName - 相机名称 (deviceType: 9)
 * @property {string} cameraIp - 相机IP (deviceType: 9)
 * @property {string} alarmTypeCode - 报警类型编码 (deviceType: 9)
 * @property {string} remark - 人员名称/备注 (deviceType: 9)
 * @property {string} alarmPictureUrl - 报警图片 (deviceType: 9 备选)
 */
import imageDetail from "./imageDetail.vue";
import ImageShow, { getFullImageUrl } from "./ImageShow.vue";
import { formatDate, formatTime } from "@/utils/timeFormat";

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    showData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      localShow: false,
      localShowData: null,
      dialogVisible: false,
      imageUrl: "",
      imageis: false,
    };
  },
  watch: {
    showData: {
      handler(val) {
        this.localShowData = val;
      },
      immediate: true,
    },
    show: {
      handler(val) {
        this.localShow = val;
      },
      immediate: true,
    },
  },
  components: {
    imageDetail,
    ImageShow,
  },
  computed: {
    activeData() {
      return this.localShowData || {};
    },
    isWarning() {
      return this.activeData.messageType == 1;
    },
    alertLevel() {
      return this.activeData.alarmLevel || 3;
    },
    alertLevelText() {
      const levels = { 1: "一级报警", 2: "二级报警", 3: "三级报警" };
      return levels[this.alertLevel] || "三级报警";
    },
    titleInfo() {
      const type = this.activeData.deviceType;
      const isWarning = this.isWarning;

      const texts = {
        1: isWarning ? "倾角预警" : "倾角报警",
        2: isWarning ? "位移预警" : "位移报警",
        5: isWarning ? "净空预警" : "净空报警",
        6: "螺栓报警",
        7: "叶片报警",
        8: "音频报警",
        9: "安全报警",
      };
      const text = texts[type] || "报警详情";

      const colors = { 1: "red", 2: "orange", 3: "yellow" };
      const color = colors[this.alertLevel] || "yellow";

      const icon = isWarning
        ? require("@/assets/image/wind/detailsyj.png")
        : require("@/assets/image/wind/detailsbj.png");

      return { text, color, icon };
    },
    displayDetails() {
      const type = this.activeData.deviceType;
      const data = this.activeData;
      const details = {
        title: data.deviceName || "",
        items: [],
      };

      // 1: 倾角, 2: 位移, 5: 净空, 6: 螺栓, 7: 叶片, 8: 音频, 9: 安全
      switch (type) {
        case 1:
        case 2:
          details.items.push({
            label: "监测数值",
            value: data.currentData != null ? Number(data.currentData).toFixed(2) : "0.00",
          });
          if (type == 2 && data.heading != null) {
            details.items.push({ label: "航向角", value: Number(data.heading).toFixed(2) });
          }
          break;
        case 5:
          details.items.push({
            label: "净空距离",
            value: data.distance != null ? (Number(data.distance) / 100).toFixed(2) + "M" : "0.00M",
          });
          break;
        case 6:
          details.items.push({
            label: "螺栓层数",
            value: data.tier || "",
          });
          details.items.push({
            label: "监测数值",
            value: data.currentData != null ? data.currentData : "0",
          });
          break;
        case 7:
          details.items.push({ label: "报警内容", value: data.alarmType || "结构裂纹" });
          break;
        case 8:
          details.items.push({ label: "报警内容", value: data.alarmType || "音频异常" });
          break;
        case 9:
          details.title = ""; // 安全报警通常不显示机组号在标题
          details.items.push({ label: "相机名称", value: data.cameraName || "" });
          details.items.push({ label: "相机IP", value: data.cameraIp || "" });
          if (data.alarmTypeCode === '100' && data.remark) {
            details.items.push({ label: "人员名称", value: data.remark });
          }
          break;
      }

      return details;
    },
    formattedTime() {
      const time = this.activeData.alarmTime;
      return {
        date: formatDate(time),
        time: formatTime(time),
      };
    },
    contentBodyClass() {
      const type = this.activeData.deviceType;
      const classes = {
        1: "content-body-7",
        2: "content-body-6",
        5: "content-body-5",
        6: "content-body-2",
        7: "content-body-5",
        8: "content-body-5",
        9: "content-body-5",
      };
      return classes[type] || "";
    },
  },
  methods: {
    handleClose() {
      this.$emit("update:show", false);
    },
    imageDetailDblclick(url, bol = true) {
      this.imageis = bol;
      this.imageUrl = url;
      this.dialogVisible = true;
    },
    getFullImageUrl: getFullImageUrl,
    angleDispose(data) {
      let numberValue = 0;
      if (data < 0.2 && data > -0.2) {
        numberValue = data * 100 * 1.5;
      } else if (data >= 0.5) {
        numberValue = (data - 0.5) * 100 * 0.6 + 60;
      } else if (data <= -0.5) {
        numberValue = (data + 0.5) * 100 * 0.6 - 60;
      } else if (data >= 0.2) {
        numberValue = (data - 0.2) * 100 * 1 + 30;
      } else if (data <= -0.2) {
        numberValue = (data + 0.2) * 100 * 1 - 30;
      }
      if (numberValue > 90) {
        numberValue = 90;
      }
      if (numberValue < -90) {
        numberValue = -90;
      }
      return numberValue;
    },
  },
};
</script>

<style lang="scss">
.main-body {
  position: relative;
  height: 100%;

  .title {
    position: absolute;
    top: 00px;
    left: calc(50% - 400px);
    width: 800px;
    height: 80px;
    text-align: center;
    line-height: 70px;
    font-size: 50px;
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;

    > img {
      height: 50px;
      margin-right: 10px;
    }

    > span {
      font-size: 40px;
    }
  }

  .content-body {
    position: absolute;
    top: 80px;
    left: 0px;
    width: 100%;
    height: 460px;

    // background-color: red;
    .left {
      position: absolute;
      left: 0;
      top: 0px;
      width: 600px;
      height: 100%;

      img,
      video {
        // height: 100%;
        width: 100%;
      }

      .max-img {
        width: 100%;
        height: 100%;
      }
    }

    .right {
      position: absolute;
      right: 0;
      top: 0;
      width: 360px;
      height: 100%;
      color: white;
      // background-color: green;
      padding-left: 40px;

      // > .title {
      //   font-size: 50px;
      //   margin-top: 20px;
      // }
      .type {
        font-size: 24px;
        margin-top: 60px;
        text-align: left;
        letter-spacing: 10px;
      }

      .date {
        font-size: 24px;
        margin-top: 10px;
        text-align: left;
        display: flex;
        letter-spacing: 2px;
      }
    }
  }

  .bottom {
    position: absolute;
    left: 0;
    bottom: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;

    > div {
      width: 200px;
      height: 50px;
      text-align: center;
      line-height: 50px;
      color: white;
      border-radius: 50px;
      border: 1px solid #96c9fc;
      background-color: #409eff;
      font-size: 20px;
    }
  }
}

.dialog-class-2 {
  z-index: 9999 !important;

  .el-dialog {
    margin: 0px !important;
    top: calc(50% - 350px) !important;
    left: calc(50% - 550px);
    height: 700px;
    width: 1100px;
    position: absolute;
    background-image: url("@/assets/image/wind/kuang4.png") !important;
    background-size: 100% 100%;
    background-color: #0000 !important;
    padding: 50px 70px !important;
  }

  .el-dialog__body {
    padding: 0px !important;
    height: 100%;
  }

  .el-dialog__header {
    height: 0px;
    padding: 0px;
  }
}

.guanbi {
  position: absolute;
  cursor: pointer;
  top: 50px;
  right: 50px;
  width: 40px;
  height: 35px;
}

.content-body-X {
  .right {
    padding-left: 30px;

    > div {
      font-size: 24px;
      margin-top: 10px;
      text-align: left;
      display: flex;
      padding-left: 10px;
    }

    .right-title {
      font-size: 30px;
      margin-top: 20px;
      text-align: left;
      letter-spacing: 10px;
    }

    .alarm-state,
    .disp-state {
      font-size: 24px;
      margin-top: 10px;
      text-align: left;
      display: flex;

      > div {
        display: flex;
        align-items: flex-end;
        font-size: 16px;
        color: rgb(6, 141, 252);
        margin-left: 20px;
        border-bottom: 1px solid rgb(6, 141, 252);
      }
    }

    .date {
      letter-spacing: 2px;
    }

    .disp-text {
      padding-left: 0px;
      height: 80px;
      width: 100%;
      // background-color: rgba(6, 141, 252, 0.3);
      border: 1px solid rgb(6, 141, 252);
      overflow-y: scroll;
      padding: 5px 10px;
    }

    ::-webkit-scrollbar {
      width: 3px !important;
    }

    ::-webkit-scrollbar-thumb {
      border-radius: 3px;
      background-color: rgba(200, 200, 200, 1);
    }

    ::-webkit-scrollbar-track {
      border-radius: 0px;
      background-color: rgba($color: #000000, $alpha: 0.1);
    }
  }
}

.content-body-4 {
  .right {
    .right-title {
      font-size: 30px;
      margin-top: 40px;
      text-align: left;
      letter-spacing: 10px;
    }

    .right-value {
      font-size: 24px;
      margin-top: 10px;
      text-align: left;
      display: flex;
      letter-spacing: 10px;
    }

    .type {
      font-size: 24px;
      margin-top: 60px;
      text-align: left;
      letter-spacing: 10px;
    }

    .date {
      font-size: 24px;
      margin-top: 10px;
      text-align: left;
      display: flex;
      letter-spacing: 2px;
    }
  }
}

.content-body-6 {
  .left {
    > div {
      height: 400px;
      width: 400px;
      margin-left: 100px;
      margin-top: 40px;
    }
  }
}

.content-body-7 {
  .left {
    display: flex;
    align-items: center;
    justify-content: center;

    > div {
      // margin-top: 200px;
      height: 300px;
      width: 400px;
    }
  }
}

.content-body-2 {
  position: absolute;
  top: 80px;
  left: 0px;
  width: 100%;
  height: 460px;
  display: flex;
  flex-wrap: wrap;

  .left {
    width: 65%;
    height: 100%;

    > .item1 {
      // height: 50%;
      display: flex;
      position: relative;

      > img {
        // height: auto;
        width: 50%;
      }

      > div {
        position: absolute;
      }

      > div:nth-child(3) {
        left: 0px;
      }

      > div:nth-child(4) {
        left: 50%;
      }
    }

    > .item2 {
      // height: 50%;
      position: relative;

      > .luoshuan {
        position: absolute;
        top: 2%;
        right: 8%;
        height: 50%;
        width: 20%;
      }

      > img {
        height: 100%;
        width: 100%;
      }
    }
  }
}

.content-body-5 {
  .left {
    display: flex;
    flex-wrap: wrap;

    img:nth-child(1),
    video:nth-child(1) {
      // height: 70%;
      width: 100%;
    }

    img:nth-child(2),
    video:nth-child(2) {
      // height: calc(30% - 5px);
      width: calc(50% - 2.5px);
      margin-top: 5px;
      margin-right: 5px;
    }

    img:nth-child(3),
    video:nth-child(3) {
      margin-top: 5px;
      // height: calc(30% - 5px);
      width: calc(50% - 2.5px);
    }
  }
}

.imageDetail {
  width: 1400px;
}
</style>
